import React from 'react';

import displayHashrateValue from 'common/displayHashrateValue';
import './AverageHashrate.scss';

interface IHashrates {
  hashrates: {
    hashrate_avg_1h: string
    hashrate_avg_5m: string
    hashrate_avg_24h: string
  }
}

const AverageHashrate = ({
  hashrates: {
    hashrate_avg_1h,
    hashrate_avg_5m,
    hashrate_avg_24h,
  },
}: IHashrates) => {
  const averages = {
    '5 Minutes': parseFloat(hashrate_avg_5m ?? '0'),
    '1 Hour': parseFloat(hashrate_avg_1h ?? '0'),
    '24 Hours': parseFloat(hashrate_avg_24h ?? '0'),
  };

  return (
    <div className='average-hashrate'>
      <h5>Average Hashrate</h5>
      {
        Object.entries(averages).map(([key, rawValue]) => {
          const { unit, value } = displayHashrateValue (rawValue);

          return (
            <div className='average-entry' key={key}>
              <div>{key}</div>
              <div>{value}<span>{unit}h/s</span></div>
            </div>
          );
        })
      }
    </div>
  );
};

export default AverageHashrate;

